/* Confronto prodotti Piquadro (sections/pq-compare.liquid)
   ------------------------------------------------------------------------
   Categoria → per ogni colonna un menu: prima le LINEE, poi i prodotti della
   linea con la miniatura (ricerca in cima su tutta la categoria) → card
   delle collezioni con il carrello → scheda tecnica affiancata.
   I dati di ogni prodotto arrivano da /products/<handle>?view=compare
   (templates/product.compare.liquid: card-product-add-to-cart, pdp-sku,
   pdp-specs della PDP). Stato nell'URL: ?c=<categoria>&p=<h1>,<h2>,<h3>. */
(() => {
  if (window.__pqCompare) return;
  window.__pqCompare = true;

  const $ = (s, r) => r.querySelector(s);
  const $$ = (s, r) => Array.from(r.querySelectorAll(s));
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const norm = s => String(s || '').replace(/\s+/g, ' ').trim();
  const fold = s => norm(s).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const cache = new Map();
  // Nome della linea come nella card: senza "Collezione", "Speciale", "Gommato", spazi in eccesso
  const cleanLine = s => norm(String(s || '').replace(/collezione|speciale|gommato/gi, ''));
  const lineKey = s => fold(cleanLine(s)).replace(/[^a-z0-9]+/g, '');

  function init(root) {
    if (root.__pqc) return;
    root.__pqc = true;
    let data;
    try { data = JSON.parse($('[data-pqc-data]', root).textContent); } catch (e) { return; }
    const T = data.t || {};
    const order = (data.linesOrder || []).map(norm).filter(Boolean);
    const cats = (data.cats || []).filter(c => c.p && c.p.length);
    const deskCols = () => parseInt(getComputedStyle(root).getPropertyValue('--pqc-cols'), 10) || 3;
    const base = String(data.root || '/').replace(/\/$/, '');
    const el = n => $(`[data-pqc-${n}]`, root);
    const catsEl = el('cats'), selEl = el('selects'), cardsEl = el('cards'), tableEl = el('table'), emptyEl = el('empty'),
      toolsEl = el('tools'), stickyEl = el('sticky'), diffEl = el('diff');

    const q = new URLSearchParams(location.search);
    const wanted = (q.get('p') || '').split(',').map(s => s.trim()).filter(Boolean);
    let cat = cats.find(c => c.h === q.get('c')) || (wanted[0] && cats.find(c => c.p.some(p => p.h === wanted[0]))) || null;
    let picks = [];
    // colore del prodotto da cui si arriva (riquadro in PDP): ?v=<id variante> vale per il primo prodotto di ?p
    let pin = (q.get('v') && wanted[0]) ? { h: wanted[0], v: q.get('v') } : null;
    const variantFor = h => (pin && pin.h === h ? pin.v : '');

    /* ---------- linee della categoria, nell'ordine scelto nell'editor ---------- */
    const linesOf = c => {
      // stessa linea scritta in modi diversi ("Brief 2", "BRIEF 2 ", "Collezione Brief 2"): un solo gruppo
      const map = new Map();
      c.p.forEach(p => {
        const k = lineKey(p.l) || '~other';
        if (!map.has(k)) map.set(k, { name: cleanLine(p.l) || T.other, products: [] });
        map.get(k).products.push(p);
      });
      const groups = [...map.entries()].map(([k, g]) => ({ key: k, name: g.name, products: g.products }));
      const rank = g => { const i = order.findIndex(o => lineKey(o) === g.key); return i < 0 ? 1e6 : i; };
      groups.sort((a, b) => (a.key === '~other') - (b.key === '~other') || rank(a) - rank(b) || a.name.localeCompare(b.name));
      return groups;
    };
    const find = h => cat && cat.p.find(p => p.h === h);
    const thumb = p => `<span class="pqc__thumb">${p && p.i ? `<img src="${esc(p.i)}" alt="" loading="lazy" width="48" height="48">` : ''}</span>`;

    /* ---------- categorie ---------- */
    // I link delle categorie sono già nell'HTML: restano navigabili senza JavaScript.
    $$('.pqc__cat', catsEl).forEach(b => { b.hidden = !cats.some(c => c.h === b.dataset.h); });
    catsEl.addEventListener('click', e => {
      const b = e.target.closest('[data-h]');
      if (!b || !cats.some(c => c.h === b.dataset.h)) return;
      e.preventDefault();
      cat = cats.find(c => c.h === b.dataset.h); picks = []; setup(true);
    });

    /* ---------- menu per colonna ---------- */
    function pickBtn(i) {
      const p = find(picks[i]);
      return `<span class="pqc__pick-txt">${p ? `${p.l ? `<small>${esc(cleanLine(p.l))}</small>` : ''}<b>${esc(p.t)}</b>` : `<b>${esc(T.choose)}</b>`}</span>`;
    }
    function setup(fresh) {
      $$('.pqc__cat', catsEl).forEach(b => b.setAttribute('aria-current', String(!!cat && b.dataset.h === cat.h)));
      if (!cat) { selEl.hidden = true; emptyEl.hidden = false; return; }
      emptyEl.hidden = true; selEl.hidden = false;
      const n = deskCols();
      if (!fresh && wanted.length) picks = wanted.filter(h => find(h));
      for (const p of cat.p) { if (picks.length >= n) break; if (!picks.includes(p.h)) picks.push(p.h); }
      picks = picks.slice(0, n);
      while (picks.length < n) picks.push('');
      selEl.innerHTML = `<div class="pqc__lab pqc__lab--head"><small>${esc(T.choose)}</small><b>${esc(cat.t)}</b><span>${esc(String(T.count || '').replace('[n]', cat.p.length))}</span></div>` + picks.map((h, i) => `
        <div class="pqc__pick" data-i="${i}">
          <button type="button" class="pqc__pick-btn" aria-haspopup="listbox" aria-expanded="false">${thumb(find(h))}${pickBtn(i)}</button>
          <div class="pqc__panel" hidden>
            <input class="pqc__search" type="search" placeholder="${esc(T.search)}" aria-label="${esc(T.search)}">
            <ul class="pqc__list" role="listbox" aria-label="${esc(T.choose)}"></ul>
          </div>
        </div>`).join('');
      render();
    }
    const refreshBtn = i => { const b = $(`.pqc__pick[data-i="${i}"] .pqc__pick-btn`, selEl); if (b) b.innerHTML = thumb(find(picks[i])) + pickBtn(i); };

    // contenuto del pannello: elenco linee, prodotti di una linea, oppure risultati della ricerca
    function fill(box, view) {
      const list = $('.pqc__list', box), i = +box.dataset.i;
      const item = p => `<li><button type="button" class="pqc__opt" role="option" data-h="${esc(p.h)}" aria-selected="${p.h === picks[i]}">${thumb(p)}<span class="pqc__pick-txt">${p.l ? `<small>${esc(cleanLine(p.l))}</small>` : ''}<b>${esc(p.t)}</b></span></button></li>`;
      if (view.search) {
        const f = fold(view.search);
        const res = cat.p.filter(p => fold(`${p.t} ${p.c} ${p.l}`).includes(f));
        list.innerHTML = res.length ? res.map(item).join('') : `<li class="pqc__none">${esc(T.noresults)}</li>`;
      } else if (view.line) {
        const L = linesOf(cat).find(x => x.key === view.line);
        list.innerHTML = `<li><button type="button" class="pqc__back" data-back>← ${esc(T.lines)}</button></li>` + (L ? L.products.map(item).join('') : '');
      } else {
        list.innerHTML = linesOf(cat).map(L => `<li><button type="button" class="pqc__opt pqc__opt--line" data-line="${esc(L.key)}"><span>${esc(L.name)}</span><span>${L.products.length}</span></button></li>`).join('');
      }
      box.__view = view;
    }
    const close = box => { if (!box) return; $('.pqc__panel', box).hidden = true; $('.pqc__pick-btn', box).setAttribute('aria-expanded', 'false'); };
    const closeAll = except => $$('.pqc__pick', selEl).forEach(b => { if (b !== except) close(b); });
    function open(box) {
      closeAll(box);
      const p = find(picks[+box.dataset.i]);
      const s = $('.pqc__search', box); s.value = '';
      fill(box, p ? { line: lineKey(p.l) || '~other' } : {});
      $('.pqc__panel', box).hidden = false;
      $('.pqc__pick-btn', box).setAttribute('aria-expanded', 'true');
      const sel = $('.pqc__opt[aria-selected="true"]', box);
      if (sel) sel.scrollIntoView({ block: 'nearest' });
      s.focus({ preventScroll: true });
    }
    selEl.addEventListener('click', e => {
      const box = e.target.closest('.pqc__pick'); if (!box) return;
      if (e.target.closest('.pqc__pick-btn')) { $('.pqc__panel', box).hidden ? open(box) : close(box); return; }
      const back = e.target.closest('[data-back]'); if (back) { fill(box, {}); return; }
      const line = e.target.closest('[data-line]'); if (line) { fill(box, { line: line.dataset.line }); return; }
      const opt = e.target.closest('.pqc__opt[data-h]');
      if (opt) { picks[+box.dataset.i] = opt.dataset.h; refreshBtn(+box.dataset.i); close(box); $('.pqc__pick-btn', box).focus(); render(); }
    });
    selEl.addEventListener('input', e => {
      const s = e.target.closest('.pqc__search'); if (!s) return;
      const box = s.closest('.pqc__pick'); const v = s.value.trim();
      fill(box, v ? { search: v } : {});
    });
    selEl.addEventListener('keydown', e => {
      const box = e.target.closest('.pqc__pick'); if (!box) return;
      if (e.key === 'Escape') { close(box); $('.pqc__pick-btn', box).focus(); return; }
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        const opts = $$('.pqc__back, .pqc__opt', box); if (!opts.length) return;
        e.preventDefault();
        const i = opts.indexOf(document.activeElement);
        const n = e.key === 'ArrowDown' ? Math.min(opts.length - 1, i + 1) : Math.max(0, i - 1);
        (i < 0 ? opts[0] : opts[n]).focus();
      }
    });
    // clic fuori dal menu: chiude. (Un bottone appena sostituito nel pannello non e' piu' nel documento: non conta come "fuori".)
    document.addEventListener('click', e => { if (e.target.isConnected && !e.target.closest('.pqc__pick')) closeAll(); });

    /* ---------- dati del prodotto ---------- */
    function load(h) {
      if (!h) return Promise.resolve(null);
      const v = variantFor(h), key = v ? `${h}#${v}` : h;
      if (cache.has(key)) return cache.get(key);
      const pr = fetch(`${base}/products/${encodeURIComponent(h)}?view=compare${v ? `&variant=${encodeURIComponent(v)}` : ''}`, { credentials: 'same-origin' })
        .then(r => { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(html => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const n = $('[data-pqc-product]', doc); if (!n) throw new Error('vuoto');
          const card = $('[data-pqc-card]', n);
          return {
            h, url: n.dataset.url, title: n.dataset.title, line: n.dataset.line, img: n.dataset.img, alt: n.dataset.imgAlt,
            g1: n.dataset.g1 || '',
            // foto del colore mostrato: si tiene quella del tipo scelto nell'editor (es. DETT3, DETTINT)
            ...(() => {
              const code = String(data.photoCode || '').toUpperCase();
              const ph = code && $$('[data-pqc-photos] [data-t]', n).find(x => String(x.dataset.t).toUpperCase() === code);
              return { dett3: ph ? ph.dataset.src : '', dett3Alt: ph ? ph.dataset.alt : '' };
            })(),
            price: ($('[data-pqc-price]', n) || {}).innerHTML || '',
            sku: ($('[data-pqc-sku]', n) || {}).innerHTML || '',
            card: card && card.textContent.trim() || (card && card.querySelector('img')) ? card.innerHTML : '',
            groups: $$('.pq-specs__group', n).map(g => ({
              title: norm(($('.pq-specs__title', g) || {}).textContent),
              rows: $$('.pq-spec__row', g).map(r => {
                const dt = $('dt', r), dd = $('dd', r);
                return { key: dt.getAttribute('data-metafields') || norm(dt.textContent), label: norm(dt.textContent), value: norm(dd.textContent) };
              })
            }))
          };
        })
        .catch(() => ({ h, error: true }));
      cache.set(key, pr);
      return pr;
    }

    /* ---------- schede e tabella ---------- */
    let token = 0;
    function render() {
      const my = ++token;
      const url = new URL(location.href);
      if (cat) url.searchParams.set('c', cat.h); else url.searchParams.delete('c');
      const ph = picks.filter(Boolean);
      if (ph.length) url.searchParams.set('p', ph.join(',')); else url.searchParams.delete('p');
      // il colore resta nell'URL finche' quel prodotto e' ancora in una colonna
      if (pin && !picks.includes(pin.h)) pin = null;
      if (pin) url.searchParams.set('v', pin.v); else url.searchParams.delete('v');
      history.replaceState(null, '', url);
      if (!ph.length) { cardsEl.innerHTML = ''; tableEl.innerHTML = ''; toolsEl.hidden = true; stickyEl.hidden = true; return; }
      tableEl.innerHTML = `<p class="pqc__loading">${esc(T.loading)}</p>`;
      Promise.all(picks.map(load)).then(list => {
        if (my !== token) return;
        cardsEl.innerHTML = `<div class="pqc__lab pqc__lab--tools"><label class="pqc__diff"><input type="checkbox" data-pqc-diff2${root.classList.contains('pqc--diff') ? ' checked' : ''}> ${esc(T.diff)}</label></div>` + list.map(p => {
          if (!p) return '<div></div>';
          if (p.error) return `<div class="pqc__cardwrap"><p class="pqc__empty">${esc(T.error)}</p></div>`;
          // la card delle collezioni; se il prodotto non ne ha una (nessuna variante disponibile) una scheda semplice
          if (p.card) return `<div class="pqc__cardwrap" data-h="${esc(p.h)}">${p.card}</div>`;
          return `<div class="pqc__card">
            <a class="pqc__img" href="${esc(p.url)}">${p.img ? `<img src="${esc(p.img)}" alt="${esc(p.alt)}" loading="lazy" width="640" height="640">` : ''}</a>
            ${p.line ? `<p class="pqc__line">${esc(p.line)}</p>` : ''}
            <h2 class="pqc__name">${esc(p.title)}</h2>
            <div class="pqc__sku">${p.sku}</div>
            <div class="pqc__price">${p.price}</div>
            <a class="pqc__cta" href="${esc(p.url)}">${esc(T.cta)}</a>
          </div>`;
        }).join('');
        alignCards();
        $('.pqc__cols', stickyEl).innerHTML = '<div class="pqc__lab"></div>' + list.map(p => p && !p.error ? `<div><b>${esc(p.title)}</b><span>${p.price}</span></div>` : '<div></div>').join('');

        const groups = [];
        list.forEach(p => (p && p.groups || []).forEach(g => {
          let G = groups.find(x => x.title === g.title);
          if (!G) groups.push(G = { title: g.title, rows: [] });
          g.rows.forEach(r => { if (!G.rows.some(x => x.key === r.key)) G.rows.push({ key: r.key, label: r.label }); });
        }));
        // foto dell'interno (_DETT3): prima riga di "Organizzazione interna", se almeno un prodotto ce l'ha
        const withPhoto = list.filter(p => p && !p.error && p.dett3);
        if (withPhoto.length) {
          const g1 = withPhoto[0].g1;
          let G = groups.find(x => x.title === g1);
          if (!G) groups.unshift(G = { title: g1, rows: [] });
          G.rows.unshift({ key: '__dett3', label: T.dett3 || '' });
        }
        const valueOf = (p, gt, key) => {
          const g = p && p.groups && p.groups.find(x => x.title === gt);
          const r = g && g.rows.find(x => x.key === key);
          return r ? r.value : '';
        };
        tableEl.innerHTML = groups.map(G => {
          let allSame = true;
          const rows = G.rows.map(R => {
            if (R.key === '__dett3') {
              allSame = false;
              return `<div class="pqc__row pqc__cols pqc__row--photo"><dt class="pqc__lab">${esc(R.label)}</dt>${list.map(p => p && p.dett3
                ? `<dd><span class="pqc__photo"><img src="${esc(p.dett3)}" alt="${esc(p.dett3Alt)}" loading="lazy" width="640" height="640"></span></dd>`
                : `<dd class="is-none">${esc(T.none)}</dd>`).join('')}</div>`;
            }
            const vals = list.map(p => valueOf(p, G.title, R.key));
            const shown = vals.filter((v, i) => list[i] && !list[i].error);
            const same = shown.length > 1 && shown.every(v => v === shown[0]);
            if (!same) allSame = false;
            return `<div class="pqc__row pqc__cols${same ? ' is-same' : ''}"><dt class="pqc__lab">${esc(R.label)}</dt>${vals.map(v => `<dd${v ? '' : ' class="is-none"'}>${v ? esc(v) : esc(T.none)}</dd>`).join('')}</div>`;
          }).join('');
          return `<section class="pqc__group${allSame ? ' is-allsame' : ''}"><h3>${esc(G.title)}</h3><dl>${rows}</dl></section>`;
        }).join('');
        // pulsante carrello in fondo a ogni colonna (solo dove c'e' la card con il suo modulo)
        tableEl.insertAdjacentHTML('beforeend', `<div class="pqc__cols pqc__buyrow"><div class="pqc__lab"></div>${list.map((p, i) =>
          p && !p.error && p.card ? `<div><button type="button" class="pqc__cta pqc__add" data-pqc-add="${i}">${esc(T.add)}</button></div>` : '<div></div>').join('')}</div>`);
        toolsEl.hidden = !groups.length;
        stickyEl.hidden = false;
        measure(); onScroll();
      });
    }

    /* ---------- pulsante carrello allineato come nelle collezioni ----------
       Lo posiziona assets/card-product-add-to-cart-position.js del tema, che pero'
       lavora solo sulle card presenti al caricamento e poi a ogni "resize". Dopo aver
       inserito le card (e quando le loro foto finiscono di caricare) gli si chiede di
       ricalcolare, con un evento resize. */
    function alignCards() {
      const kick = () => window.dispatchEvent(new Event('resize'));
      requestAnimationFrame(kick);
      $$('img', cardsEl).forEach(img => { if (!img.complete) img.addEventListener('load', kick, { once: true }); });
    }

    /* ---------- carrello dalla card: come la griglia di collezione ----------
       Il tema collega i moduli /cart/add solo al caricamento della pagina; per
       le card arrivate dopo si fa lo stesso qui, e l'evento shopify:cart_add
       aggiorna e apre il carrello laterale come nelle collezioni. */
    function addToCart(form, done) {
      fetch(`${base}/cart/add.js`, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
        .then(r => { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(() => { document.dispatchEvent(new CustomEvent('shopify:cart_add')); done(true); })
        .catch(() => done(false));
    }
    // il modulo della card (anche se nascosto il suo pulsante) resta il riferimento:
    // variante, proprieta' e disponibilita' sono quelle che la card ha calcolato
    cardsEl.addEventListener('submit', e => {
      const form = e.target.closest('form[action$="/cart/add"]'); if (!form) return;
      e.preventDefault();
      addToCart(form, () => {});
    });
    tableEl.addEventListener('click', e => {
      const btn = e.target.closest('[data-pqc-add]'); if (!btn || btn.disabled) return;
      const wraps = $$(':scope > :not(.pqc__lab)', cardsEl);
      const form = wraps[+btn.dataset.pqcAdd] && $('form[action$="/cart/add"]', wraps[+btn.dataset.pqcAdd]);
      if (!form) return;
      btn.disabled = true;
      addToCart(form, ok => {
        btn.disabled = false;
        if (!ok) return;
        btn.classList.add('is-done'); btn.textContent = T.added || T.add;
        setTimeout(() => { btn.classList.remove('is-done'); btn.textContent = T.add; }, 2500);
      });
    });

    // due interruttori uguali: nella colonna sinistra su desktop, sopra la tabella su mobile
    root.addEventListener('change', e => {
      const t = e.target.closest('[data-pqc-diff], [data-pqc-diff2]'); if (!t) return;
      root.classList.toggle('pqc--diff', t.checked);
      $$('[data-pqc-diff], [data-pqc-diff2]', root).forEach(x => { x.checked = t.checked; });
    });

    /* ---------- riga fissa sotto la testata del sito ---------- */
    function measure() {
      let top = 0;
      const sel = root.dataset.header;
      try {
        const h = sel && document.querySelector(sel);
        if (h) { const cs = getComputedStyle(h); if (cs.position === 'sticky' || cs.position === 'fixed') top = Math.round(h.getBoundingClientRect().height); }
      } catch (e) {}
      root.style.setProperty('--pqc-top', top + 'px');
    }
    const onScroll = () => {
      if (stickyEl.hidden) return;
      const top = parseInt(getComputedStyle(root).getPropertyValue('--pqc-top'), 10) || 0;
      stickyEl.classList.toggle('is-on', cardsEl.getBoundingClientRect().bottom < top + 8 && tableEl.getBoundingClientRect().bottom > top + 80);
    };
    addEventListener('resize', measure);
    addEventListener('scroll', onScroll, { passive: true });

    setup(false);
  }

  const boot = () => $$('[data-pqc]', document).forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', e => $$('[data-pqc]', e.target).forEach(r => { r.__pqc = false; init(r); }));
})();
